module.exports = __webpack_public_path__ + "img/afrikaans-home.197139c7.svg";